import React, { useState, useEffect } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";

function BasicExpertSettings(props) {
  const [approveOwnKnowledge, setApproveOwnKnowledge] = useState(false);
  const [reviewOwnKnowledge, setReviewOwnKnowledge] = useState(false);
  const [autostartApproval, setAutostartApproval] = useState(false);
  const [automaticPublish, setAutomaticPublish] = useState(false);
  const [reviewersRequired, setReviewersRequired] = useState(1);
  const [approversRequired, setApproversRequired] = useState(1);
  const { t } = useTranslation();

  useEffect(
    () => {
      settingsUpdated();
    },
    [
      approveOwnKnowledge,
      reviewOwnKnowledge,
      autostartApproval,
      automaticPublish,
      reviewersRequired,
      approversRequired,
    ]
  );

  useEffect(
    () => {
      if (props.editKs && Object.keys(props.editKs).length > 0) {
        setReviewOwnKnowledge(
          !!props.editKs.properties.sourceProperties.reviewOwnKnowledge
        );
        setApproveOwnKnowledge(
          !!props.editKs.properties.sourceProperties.approveOwnKnowledge
        );
        setReviewersRequired(
          props.editKs.properties.sourceProperties.reviewersRequired
            ? parseInt(
                props.editKs.properties.sourceProperties.reviewersRequired
              )
            : 0
        );
        setApproversRequired(
          props.editKs.properties.sourceProperties.approversRequired
            ? parseInt(
                props.editKs.properties.sourceProperties.approversRequired
              )
            : 0
        );
        setAutomaticPublish(
          !!props.editKs.properties.sourceProperties.automaticPublish
        );
        setAutostartApproval(
          !!props.editKs.properties.sourceProperties.autostartApproval
        );
      }
    },
    [props.editKs]
  );

  const settingsUpdated = () => {
    props.setSourceProperties({
      reviewOwnKnowledge,
      approveOwnKnowledge,
      reviewersRequired,
      approversRequired,
      automaticPublish,
      autostartApproval,
    });
  };

  return (
    <div style={{ margin: "25px 0px" }}>
      <Typography gutterBottom variant="h5">
        {t("content_workflow_settings")}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t("ks_workflow_settings_subheader")}
      </Typography>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <FormControl style={{ width: "15%", marginBottom: 5 }}>
          <TextField
            label={t("content_workflow_num_reviewers")}
            inputProps={{ min: "0" }}
            value={reviewersRequired}
            onChange={(e) => setReviewersRequired(e.target.value)}
            type="number"
          />
        </FormControl>
        <FormControl style={{ width: "15%" }}>
          <TextField
            label={t("content_workflow_num_approvers")}
            inputProps={{ min: "0" }}
            value={approversRequired}
            onChange={(e) => setApproversRequired(e.target.value)}
            type="number"
          />
        </FormControl>

        <FormControl>
          <FormControlLabel
            label={t("content_workflow_review_own_knowledge")}
            control={
              <Checkbox
                value=""
                checked={reviewOwnKnowledge}
                onChange={(e) => setReviewOwnKnowledge(e.target.checked)}
                color="primary"
              />
            }
          />
        </FormControl>
        <FormControl>
          <FormControlLabel
            label={t("content_workflow_approve_own_knowledge")}
            control={
              <Checkbox
                value=""
                checked={approveOwnKnowledge}
                onChange={(e) => setApproveOwnKnowledge(e.target.checked)}
                color="primary"
              />
            }
          />
        </FormControl>
        <FormControl>
          <FormControlLabel
            label={t("content_workflow_auto_publish")}
            control={
              <Checkbox
                value=""
                checked={automaticPublish}
                onChange={(e) => setAutomaticPublish(e.target.checked)}
                color="primary"
              />
            }
          />
          <FormHelperText>
            {t("content_workflow_auto_publish_helper_text")}
          </FormHelperText>
        </FormControl>
        <FormControl>
          <FormControlLabel
            label={t("content_workflow_autostart_approval")}
            control={
              <Checkbox
                value=""
                checked={autostartApproval}
                onChange={(e) => setAutostartApproval(e.target.checked)}
                color="primary"
              />
            }
          />
          <FormHelperText>
            {t("content_workflow_autostart_approval_helper_text")}
          </FormHelperText>
        </FormControl>
      </div>
    </div>
  );
}

export default BasicExpertSettings;
